import React from "react";

import CampaignHeaderCard from "./CampaignHeaderCard";
import CampaignSocialMediaCard from "./CampaignSocialMediaCard";
import { v4 as uuidv4 } from "uuid";
import OrganicPostCard from "../../../../components/client/organic_social/OrganicPostCard";


const CampaignCard = ({
  campaign,
  setCampaignId,
  setShow,
  getCampaignList
}) => {



  return (
    <div className="py-3 border_top">
      {/* campaign header card */}
      <CampaignHeaderCard
        campaign_id={campaign?.campaign_id}
        campaign_name={campaign?.campaign_name}
        start_date={campaign?.start_date}
        end_date={campaign?.end_date}
        created_at={campaign?.created_at}
        setCampaignId={setCampaignId}
        setShow={setShow}
        status={campaign?.status ? campaign?.status : ""}
        userList={campaign?.users||[]}
        ads_platform_status={campaign?.ads_platform_status || {}}
      />

      {/* social media accordian */}

      <div className="mx-4 ads_list">
        <AssociatedAdsList
          key={campaign.campaign_id}
          ads_list={campaign?.ads_list}
          getCampaignList={getCampaignList}
        />
      </div>
       
 
      
      {/* organic posts list */}
      <div className="mx-4 my-2 ads_list">
        <div className="d-flex py-3 justify-content-center align-items-center">
          <h5 className="text-center aeonik_bold">Organic Posts</h5>
        </div>
        {campaign?.organic_posts?.length > 0 ? (
          campaign?.organic_posts?.map((post) => (
            <OrganicPostCard key={post?.post_id} postDetails={post} getCampaignList={getCampaignList} />
          ))
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <h6 className="text_color_tertiary">
              No Organic Posts available.
            </h6>
          </div>
        )}


      </div>




      <div>
         {/* <h1>Organic Posts List</h1> */}
      </div>






    </div>
  );
};

export default CampaignCard;



const AssociatedAdsList = ({ ads_list,getCampaignList }) => {
  
  return (
    <div className="" id={ads_list?.ads_id}>
      <div className="d-flex flex-column gap_md">
        {ads_list?.length > 0 ? (
          ads_list?.map((ad) => (
            <CampaignSocialMediaCard
              key={uuidv4()}
              asociatedAd={ad}
              getCampaignList={getCampaignList}
            />
          ))
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            {/* <h5>No Social Media Metrics Found</h5> */}
            <h6 className="text_color_tertiary">
              No Ads available.
            </h6>
          </div>
        )}
      </div>
    </div>
  );
};
